import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SectionList } from 'site-modules/shared/components/editorial/section-list/section-list';

import './article-menu.scss';

export function defaultTrackingValueDecorator({ name }) {
  return `${name} - right`;
}

export function ArticleMenu({
  title,
  links,
  className,
  titleClassName,
  linksClassName,
  moreLink,
  itemsClassName,
  titleContainerClassName,
  listClassName,
  moreLinkClassName,
  dividerClassName,
  dataTrackingId,
  trackingValueDecorator,
  useSeparators,
  listStyle,
  ...restProps
}) {
  return (
    links.length > 0 && (
      <div className={classnames('article-menu small', className)} {...restProps}>
        <h2 className={classnames('mb-0', titleContainerClassName, titleClassName)}>{title}</h2>
        <hr className={dividerClassName} />
        <SectionList
          links={links}
          moreLink={moreLink}
          className={itemsClassName}
          listClassName={listClassName}
          linksClassName={linksClassName}
          moreLinkClassName={moreLinkClassName}
          trackingValueDecorator={trackingValueDecorator}
          dataTrackingId={dataTrackingId}
          useSeparators={useSeparators}
          listStyle={listStyle}
        />
      </div>
    )
  );
}

ArticleMenu.propTypes = {
  title: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      href: PropTypes.string,
      date: PropTypes.string,
      dataTrackingId: PropTypes.string,
      dataTrackingValue: PropTypes.string,
    })
  ).isRequired,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  linksClassName: PropTypes.string,
  titleContainerClassName: PropTypes.string,
  listClassName: PropTypes.string,
  itemsClassName: PropTypes.string,
  moreLinkClassName: PropTypes.string,
  dividerClassName: PropTypes.string,
  trackingValueDecorator: PropTypes.func,
  dataTrackingId: PropTypes.string,
  moreLink: PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string,
    accessibleText: PropTypes.string,
  }),
  useSeparators: PropTypes.bool,
  listStyle: PropTypes.shape({}),
};

ArticleMenu.defaultProps = {
  className: '',
  titleClassName: 'fw-bold text-uppercase text-gray-darker',
  linksClassName: undefined,
  titleContainerClassName: 'py-0_75 px-1 small bg-gray-lighter',
  moreLinkClassName: undefined,
  listClassName: null,
  itemsClassName: 'px-1 pt-0_75 pb-1 article-menu-item bg-gray-extra-light',
  dividerClassName: 'hidden-lg-up mt-0',
  dataTrackingId: 'inline_article_view_content',
  trackingValueDecorator: defaultTrackingValueDecorator,
  moreLink: null,
  useSeparators: false,
  listStyle: undefined,
};
